import Tags from '@/features/tags'
import { listTagsQuery } from '@/queries/tags.query'
import { TagFilters } from '@/types/filters/tag'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/contacts/segment')({
  component: Tags,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listTagsQuery)
  },
  head: () => ({
    meta: [
      {
        title: 'Segmentos | Wazai',
      },
    ],
  }),
  validateSearch: () => ({}) as TagFilters,
})
